import { render, staticRenderFns } from "./ExpenseModal.vue?vue&type=template&id=6d2bfc94&scoped=true&"
import script from "./ExpenseModal.vue?vue&type=script&lang=js&"
export * from "./ExpenseModal.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseModal.vue?vue&type=style&index=0&id=6d2bfc94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2bfc94",
  null
  
)

export default component.exports